// extracted by mini-css-extract-plugin
module.exports = {"component":"icon_component__bDvOa","icon":"icon_icon__MtTY2"};